"use client";

import { Carousel, CarouselContent, CarouselItem } from "@templates/design-system";
import AutoScroll from "embla-carousel-auto-scroll";
import { useRef } from "react";
import { getComponent } from "../../../../client";
import { RavioliMedia } from "../RavioliMedia/RavioliMedia";
import type { ILogoCloudCarouselProps } from "./LogoCloudCarousel.props";

export const LogoCloudCarousel = ({ items }: ILogoCloudCarouselProps) => {
  const Link = getComponent("Link");
  const autoScroll = useRef(
    AutoScroll({
      direction: "backward",
      playOnInit: true,
      speed: 1.5,
      startDelay: 0,
      stopOnFocusIn: true,
      stopOnInteraction: false,
      stopOnMouseEnter: true,
    }),
  );
  const repeatedItems = [
    ...items.map((item) => ({ hidden: false, item })),
    ...items.map((item) => ({ hidden: true, item })),
  ];
  return (
    <Carousel
      aria-label="Affiliated organizations"
      className="w-full max-w-full overflow-hidden"
      opts={{ align: "start", dragFree: true, loop: true }}
      plugins={[autoScroll.current]}
      tabIndex={0}
    >
      <CarouselContent className="-ml-3" viewportClassName="py-4">
        {repeatedItems.map(({ hidden, item }, index) => {
          const logo = (
            <RavioliMedia
              className="h-28 w-56 border border-primary bg-collection p-6"
              imageClassName="object-contain transition-transform duration-200 group-hover:scale-105"
              media={item.logo}
              sizes="224px"
            />
          );
          return (
            <CarouselItem
              aria-hidden={hidden || undefined}
              className="basis-auto pl-3"
              key={`${hidden ? "repeat" : "authored"}-${index}`}
            >
              {item.logoLink && !hidden ? (
                <Link
                  aria-label={item.logoLink.accessibilityLabel || item.logoLink.label}
                  className="group block focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
                  href={item.logoLink.href}
                  rel={item.logoLink.openInNewTab ? "noopener noreferrer" : undefined}
                  target={item.logoLink.openInNewTab ? "_blank" : undefined}
                >
                  {logo}
                </Link>
              ) : (
                logo
              )}
            </CarouselItem>
          );
        })}
      </CarouselContent>
    </Carousel>
  );
};

LogoCloudCarousel.displayName = "Content::LogoCloudCarousel";
